import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import Questions from './components';
import ExplainText from './components/ExplainText';

const OlympicResultDetail = ({ data, visible, setModalVisible, questionIndex }) => {
  // console.log("🚀 ~ file: index.js ~ line 5 ~ OlympicResultDetail ~ data", data[questionIndex])
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleOk = () => {
    setIsModalVisible(false);
    setModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setModalVisible(false);
  };
  React.useEffect(() => {
    setIsModalVisible(visible);
  }, [visible]);
  const { question, userData } = data[questionIndex];
  const Question = Questions[question.type];

  return (
    <Modal
      centered
      width="80%"
      visible={isModalVisible}
      onCancel={handleCancel}
      closable={false}
      footer={[
        <Button
          type='primary'
          key='close-modal'
          onClick={() => {
            handleOk(false);
          }}
        >
          Đóng
        </Button>,
      ]}
    >
      <Question data={question} ExplainText={<ExplainText data={question} />} onSubmit={() => ''} userData={userData} questionIndex={question.id} />
    </Modal>
  );
};

export default OlympicResultDetail;
